import type { IncidentStatus, SeverityCounts, Severity } from '@prerender/diagnostics-api';
import { SEVERITIES } from '@prerender/diagnostics-api';
import { Link } from 'react-router-dom';

import { DEFAULT_INCIDENT_LIST_PARAMS, serialiseIncidentListParams } from './incidentListParams';
import { DIAGNOSTICS_ROUTE } from './routes';
import { severityLabel } from './severityLabels';

type SeverityCountsListProps = {
  counts: SeverityCounts;
};

const OPEN_STATUSES: IncidentStatus[] = ['active', 'monitoring'];

const openIncidentsOf = (severity: Severity): string =>
  `${DIAGNOSTICS_ROUTE}?${serialiseIncidentListParams({
    ...DEFAULT_INCIDENT_LIST_PARAMS,
    severities: [severity],
    statuses: OPEN_STATUSES,
  })}`;

function SeverityCountsList({ counts }: SeverityCountsListProps) {
  return (
    <ul className="diagnostics-severity-counts">
      {SEVERITIES.map((severity) => (
        <li key={severity}>
          <Link to={openIncidentsOf(severity)} className="diagnostics-severity-count-link">
            <span className={`diagnostics-severity-dot diagnostics-severity-dot-${severity}`} aria-hidden="true" />
            <span className="diagnostics-severity-count">{counts[severity]}</span> {severityLabel(severity)}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default SeverityCountsList;
